import { UserDataAdapter } from "../../presentation/adpters/UserDataAdapter";

export class RolesUtils {
    static userIsInRole({ user = new UserDataAdapter().user(), roles }) {
        if (!roles) return false;
        if (!user) return false;

        return roles.includes(user.role);
    }
}
